export default "__VITE_ASSET__3ff9efad__"